import { OrgName } from "../environment";

export default {
  computed: {
    EBK() {
      return OrgName === "EBK" ? true : false;
    },
  },
};
